import {useAccount, useIsAuthenticated} from "@mytour/platform";
import {Navigate, useLocation} from "react-router";
import {LoginPage} from "./LoginPage";

export function StandardLoginPage() {
  const location = useLocation();
  const {isAuthenticated, isAuthenticatedLoading} = useIsAuthenticated();
  const {account, isSessionLoading} = useAccount();

  const {from} = (location.state as any) || {from: {pathname: "/", search: location.search}};
  if (isAuthenticatedLoading || (isAuthenticated && isSessionLoading)) {
    return null;
  }

  if (isAuthenticated && account) {
    return <Navigate to={from} replace />;
  }
  return <LoginPage />;
}
